import { render } from "./ResearcherInnovation.vue?vue&type=template&id=27eafa2c&scoped=true"
import script from "./ResearcherInnovation.vue?vue&type=script&lang=js"
export * from "./ResearcherInnovation.vue?vue&type=script&lang=js"

import "./ResearcherInnovation.vue?vue&type=style&index=0&id=27eafa2c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27eafa2c"]])

export default __exports__